
  import {Component, Vue} from 'vue-property-decorator';
  import {Action, Getter} from 'vuex-class';
  import S3Image from '@/components/S3Image.vue';
  import Loader from '@/components/Loader.vue';

  @Component({
    components: {
      Loader,
      S3Image,
    },
  })
  export default class Dashboard extends Vue {
    private loading: boolean = false;
  }
